import './AvatarGroup.css';
export var additionalAvatarWrapper = '_129un530-3-12-1';
export var avatarGroupItemWrapper = '_129un531-3-12-1';